import { render, staticRenderFns } from "./NextPage.vue?vue&type=template&id=19baec32&"
import script from "./NextPage.vue?vue&type=script&lang=ts&"
export * from "./NextPage.vue?vue&type=script&lang=ts&"
import style0 from "./NextPage.vue?vue&type=style&index=0&id=19baec32&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports